<template>
  <div id="activity" class="maincont child system-diagram-display">
      <div class="ef--inner2">
        <div class="filter">
          <div class="filter-condition admin-home-filter-condition w-100">
            <ul class="filter-condition-list">
              <li class="filter-condition-list-item">
                <label>系統図選択</label>
                <span class="select-box">
                  <select 
                    class="sel"
                    name ="systemDiagramId"
                    v-model="systemDiagram.id"
                    data-vv-as="系統図画像ファイル"
                    v-validate="'excluded:0'"
                    @change="onDisplaySystemDiagram">
                    <option 
                      v-for="(option, index) in systemDiagramDataList" 
                      v-bind:value="option.id"
                      v-bind:key="index" >{{ option.name }}</option>
                  </select>
                </span>
                <div class="err_message" v-show="errors.has('systemDiagramId')">
                  系統図を選択してください。
                </div>
              </li>
              <li class="filter-condition-list-item"><button class="bt-cyan" @click="loadSystemDiagramSetting" :disabled="isDisabledUpdateButton">更新</button></li>
            </ul>
          </div>
        </div>
      </div>
      <div class="ef--inner2">
        <div class="scroll">
          <div 
              id="system_diagram_display_display_container" 
              class="system-diagram-display-container"
              :style="canvasParentStyle"
              v-show="isShowDiagram"
              >
            <canvas ref="canvas_background"></canvas>
            <canvas ref="canvas_layer_1" id="canvas_layer_1"></canvas>
            <canvas ref="canvas_layer_2" id="canvas_layer_2"></canvas>
            <canvas ref="canvas_layer_3" id="canvas_layer_3"></canvas>

            <canvas ref="dynamic_canvas_layer_1" id="dynamic_canvas_layer_1"></canvas>
            <canvas ref="dynamic_canvas_layer_2" id="dynamic_canvas_layer_2"></canvas>
            <canvas ref="dynamic_canvas_layer_3" id="dynamic_canvas_layer_3"></canvas>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import Utils from "../../utils/utils";

/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
export default {
  name: "system-diagram-display",
  data: function () {
    return {
      accountId: '',
      clusterId: 0,
      areaId: 0,
      systemType: '',
      systemDiagram: {
        id: 0,
        name: '',
        fileUrl: ''
      },
      systemDiagramDataList: [],
      systemDiagramSettingDataList: [],
      systemDiagramSettingDynamicDataList: [],
      canvasWidth: 0,
      canvasHeight: 0,
      backgroundContext: null,
      layer1Context: null,
      layer2Context: null,
      layer3Context: null,
      dynamicLayer1Context: null,
      dynamicLayer2Context: null,
      dynamicLayer3Context: null,
      isShowDiagram: false,
      polling: null,
      indexOfList: 0,
      indexOfDynamicList: 0,
      isDisabledUpdateButton: false
    }
  }, 
  computed: {
      canvasParentStyle() {
          return {
              width: `${this.canvasWidth}px`,
              height: `${this.canvasHeight}px`
          }
      }
  },
  mounted: function () {
    this.accountId = this.$store.state.childID;
    console.log("system-diagram-display:mountedwith accountId : %o", this.accountId);
    this.getClusterIdAndAreaId()
  },
  beforeDestroy: function() {
    clearInterval(this.polling)
  },
  methods: {
    getClusterIdAndAreaId: function() {
        const params = new URLSearchParams();
        params.append("account", this.accountId);

        const request = {
            params: params,
            withCredentials: true
        };

        this.$axios
        .get(`/srv/api/account_master_es/cluster_id_and_area_id`, request)
        .then(response => {
            console.log("[GET][api/account_master_es/cluster_id_and_area_id] : OK");
            if (typeof response.data == "object") {
                this.areaId = response.data.area_id;
                this.clusterId = response.data.cluster_id;
                this.systemType = response.data.system_type;

                this.getsystemDiagramDataList();
            } else {
                // stringのときはセッションタイムアウト
                alert("sesssion time out");
                this.$store.dispatch("logout");
                this.$router.push("/login");
            }
        })
        .catch(error => {
            console.log(error);
        });
    },
    pollData: function(){

      this.polling = setInterval(() => {
        if (!this.systemDiagram.id) return
        
        if (!this.systemDiagram.id){
          this.isShowDiagram = false
        } else {
          this.isShowDiagram = true
          this.loadDynamicSystemDiagramSetting()
        }
      }, 1000*60) // one minute
    },
    getsystemDiagramDataList: function() {
      const params = new URLSearchParams();
      params.append("cluster_id", this.clusterId);
      params.append("area_id", this.areaId);

      const request = {
        params: params,
        withCredentials: true
      };

      this.$axios
      .get(`/srv/api/system_diagram_display`, request)
      .then(response => {
        if (typeof response.data == "object") {
          console.log("[GET]-[list system diagram]: OK");
          this.systemDiagramDataList = response.data.system_diagram_info;

          if (this.systemDiagramDataList && this.systemDiagramDataList.length > 0) {
            const systemDiagramInfo = this.systemDiagramDataList[0]

            if (systemDiagramInfo) {
              this.systemDiagram.id = systemDiagramInfo.id
              this.onDisplaySystemDiagram()
            }
          }
        } else {
          // stringのときはセッションタイムアウト
          alert("sesssion time out");
          this.$store.dispatch("logout");
          this.$router.push("/login");
        }
      })
      .catch(error => {
        console.log(error);
      });
    },
    onDisplaySystemDiagram: function() {
      if (!this.systemDiagram.id) return
      this.isShowDiagram = true

      const params = new URLSearchParams();
      params.append("cluster_id", this.clusterId);
      params.append("area_id", this.areaId);

      const request = {
        params: params,
        withCredentials: true
      };

      this.$axios
      .get(`/srv/api/system_diagram_display/${this.systemDiagram.id}`, request)
      .then(response => {
        if (typeof response.data == "object") {
          console.log("[GET]-[system diagram info by id]: OK");
          this.systemDiagram.name = response.data.name
          this.systemDiagram.fileName = response.data.file_name
          this.systemDiagram.fileUrl = response.data.file_url

          this.renderBackground()
        } else {
          // stringのときはセッションタイムアウト
          alert("sesssion time out");
          this.$store.dispatch("logout");
          this.$router.push("/login");
        }
      })
      .catch(error => {
        console.log(error);
      });
    },
    loadSystemDiagramSetting: function() {
      this.resetInterval()
      this.resetLayer()
      this.resetDynamicLayer()

      const params = new URLSearchParams();
      params.append("cluster_id", this.clusterId);
      params.append("area_id", this.areaId);

      const request = {
        params: params,
        withCredentials: true
      };
      this.$axios
      .get(`/srv/api/system_diagram_display/settings/${this.systemDiagram.id}`, request)
      .then(response => {
        if (typeof response.data == "object") {
                console.log("[GET]-[system diagram settings by id]: OK");
                this.systemDiagramSettingDataList = response.data.system_diagram_display;
                this.renderLayer()
            } else {
                // stringのときはセッションタイムアウト
                alert("sesssion time out");
                this.$store.dispatch("logout");
                this.$router.push("/login");
            }
        })
        .catch(error => {
            console.log(error);
        });
    },
    loadDynamicSystemDiagramSetting: function() {
      this.resetDynamicLayer()

      const params = new URLSearchParams();
      params.append("cluster_id", this.clusterId);
      params.append("area_id", this.areaId);

      const request = {
        params: params,
        withCredentials: true
      };
      this.$axios
      .get(`/srv/api/system_diagram_display/settings/dynamic/${this.systemDiagram.id}`, request)
      .then(response => {
        if (typeof response.data == "object") {
                console.log("[GET]-[system diagram settings dynamic by id]: OK");
                this.systemDiagramSettingDynamicDataList = response.data.system_diagram_display;
                this.renderDynamicLayer(true)
            } else {
                // stringのときはセッションタイムアウト
                alert("sesssion time out");
                this.$store.dispatch("logout");
                this.$router.push("/login");
            }
        })
        .catch(error => {
            console.log(error);
        });
    },
    renderBackground: function() {
      if (this.backgroundContext) {
        this.backgroundContext.clearRect(0,0,0, 0)
      }
      this.backgroundContext = this.$refs['canvas_background'].getContext('2d')

      let img = new Image();
      img.src = this.systemDiagram.fileUrl

      img.onload = function() {
          this.canvasWidth = img.width
          this.canvasHeight = img.height

          this.$refs['canvas_background'].width = this.canvasWidth
          this.$refs['canvas_background'].height = this.canvasHeight
          
          this.backgroundContext.drawImage(img, 0, 0)
          this.loadSystemDiagramSetting()
      }.bind(this)
    },
    resetInterval: function() {
      // reset interval
      if (this.polling) {
        clearInterval(this.polling)
      }
      this.pollData()
    },
    resetLayer: function() {
      this.indexOfList = 0
      if (this.layer1Context) {
        this.layer1Context.clearRect(0,0,this.canvasWidth, this.canvasHeight)
      }
      if (this.layer2Context) {
        this.layer2Context.clearRect(0,0,this.canvasWidth, this.canvasHeight)
      }
      if (this.layer2Context) {
        this.layer3Context.clearRect(0,0,this.canvasWidth, this.canvasHeight)
      }
    },
    resetDynamicLayer: function() {
      this.indexOfListDynamic = 0
      if (this.dynamicLayer1Context) {
        this.dynamicLayer1Context.clearRect(0,0,this.canvasWidth, this.canvasHeight)
      }
      if (this.dynamicLayer2Context) {
        this.dynamicLayer2Context.clearRect(0,0,this.canvasWidth, this.canvasHeight)
      }
      if (this.dynamicLayer3Context) {
        this.dynamicLayer3Context.clearRect(0,0,this.canvasWidth, this.canvasHeight)
      }
    },
    renderLayer: function() {
      this.$refs['canvas_layer_1'].width = this.canvasWidth
      this.$refs['canvas_layer_1'].height = this.canvasHeight

      this.$refs['canvas_layer_2'].width = this.canvasWidth
      this.$refs['canvas_layer_2'].height = this.canvasHeight

      this.$refs['canvas_layer_3'].width = this.canvasWidth
      this.$refs['canvas_layer_3'].height = this.canvasHeight

      this.layer1Context = this.$refs['canvas_layer_1'].getContext('2d')
      this.layer2Context = this.$refs['canvas_layer_2'].getContext('2d')
      this.layer3Context = this.$refs['canvas_layer_3'].getContext('2d')

      this.renderDynamicLayer(false)
    },
    renderDynamicLayer: function(isDynamic) {
      this.isDisabledUpdateButton = true
      // for dynamic data
      this.$refs['dynamic_canvas_layer_1'].width = this.canvasWidth
      this.$refs['dynamic_canvas_layer_1'].height = this.canvasHeight

      this.$refs['dynamic_canvas_layer_2'].width = this.canvasWidth
      this.$refs['dynamic_canvas_layer_2'].height = this.canvasHeight

      this.$refs['dynamic_canvas_layer_3'].width = this.canvasWidth
      this.$refs['dynamic_canvas_layer_3'].height = this.canvasHeight

      this.dynamicLayer1Context = this.$refs['dynamic_canvas_layer_1'].getContext('2d')
      this.dynamicLayer2Context = this.$refs['dynamic_canvas_layer_2'].getContext('2d')
      this.dynamicLayer3Context = this.$refs['dynamic_canvas_layer_3'].getContext('2d')
      
      this.renderSystemDiagramSetting(isDynamic)
    },
    renderSystemDiagramSetting: function(isDynamic) {
      let item;
      if (isDynamic) {
        item = this.systemDiagramSettingDynamicDataList[this.indexOfListDynamic]
      } else {
        item = this.systemDiagramSettingDataList[this.indexOfList]
      }

      if (item) {
        switch(item.division_id) {
          case 0: // 'blank'
            if (isDynamic) {
              this.indexOfListDynamic++
            } else {
              this.indexOfList++
            }
            this.renderSystemDiagramSetting(isDynamic)
            break;
          case 1: // 'binary_icon'
            this.renderBinaryIcon(item, isDynamic)
            break;
          case 2: // 'icon'
            this.renderIcon(item, isDynamic)
            break;
          case 3: // 'numerical'
            this.renderNumerical(item, isDynamic)
            break;
          case 4: // 'text'
            this.renderText(item, isDynamic)
            break;
          case 5: // 'date'
            this.renderDate(item, isDynamic)
            break;
        }
      } else {
        this.isDisabledUpdateButton = false
      }
    },
    renderBinaryIcon: function(info, isDynamic) {
      let ctx = this.getLayerContext(info.layer, info.division_id)

      const inforValue = info.value
      if (inforValue === '1') { // is on
        let on_icon = new Image()
        on_icon.src = info.file_url_on_icon

        on_icon.onload = function() {
          if (info.on_icon_x && info.on_icon_y) {
            ctx.drawImage(on_icon, info.axis_x, info.axis_y, info.on_icon_x , info.on_icon_y)
          } else {
            ctx.drawImage(on_icon, info.axis_x, info.axis_y)    
          }
          
          this.nextElement(isDynamic)
        }.bind(this)
      } else if (inforValue === '0') { // is off

        let off_icon = new Image();
        off_icon.src = info.file_url_off_icon

        off_icon.onload = function() {
          if (info.off_icon_x && info.off_icon_y) {
            ctx.drawImage(off_icon, info.axis_x, info.axis_y, info.off_icon_x , info.off_icon_y)
          } else {
            ctx.drawImage(off_icon, info.axis_x, info.axis_y)
          }

          this.nextElement(isDynamic)
        }.bind(this)
      } else {
        this.nextElement(isDynamic)
      }
    },
    renderIcon: function(info, isDynamic) {
      let ctx = this.getLayerContext(info.layer, info.division_id)

      let on_icon = new Image();
      on_icon.src = info.file_url_on_icon
      on_icon.onload = function() {
        if (info.on_icon_x && info.on_icon_y) {
          ctx.drawImage(on_icon, info.axis_x, info.axis_y, info.on_icon_x , info.on_icon_y)
        } else {
          ctx.drawImage(on_icon, info.axis_x, info.axis_y)    
        }
        this.nextElement(isDynamic)
      }.bind(this)
    },
    renderNumerical: function(info, isDynamic) {
      let ctx = this.getLayerContext(info.layer, info.division_id)

      if (info.value) {
        ctx.fillStyle = Utils.getFontColorName(info.font_color)
        ctx.font = this.getFont(info.font_style, info.font_size)
        ctx.fillText(info.value, info.axis_x, info.axis_y + info.font_size);
      }

      this.nextElement(isDynamic)
    },
    renderText: function(info, isDynamic) {
      let ctx = this.getLayerContext(info.layer, info.division_id)

      ctx.fillStyle = Utils.getFontColorName(info.font_color)
      ctx.font = this.getFont(info.font_style, info.font_size)
      ctx.fillText(info.text, info.axis_x, info.axis_y + info.font_size);

      this.nextElement(isDynamic)
    },
    renderDate: function(info, isDynamic) {
      let ctx = this.getLayerContext(info.layer, info.division_id)

      if (info.value) {
        ctx.fillStyle = Utils.getFontColorName(info.font_color)
        ctx.font = this.getFont(info.font_style, info.font_size)
        ctx.fillText(info.value, info.axis_x, info.axis_y + info.font_size);
      }
      this.nextElement(isDynamic)
    },
    getLayerContext: function(layer, divisionId) {
      // for dynamic
      if (divisionId === 1 || divisionId === 3 || divisionId === 5) {
        switch (layer) {
          case 1:
              return this.dynamicLayer1Context
          case 2:
              return this.dynamicLayer2Context
          case 3:
              return this.dynamicLayer3Context
        }    
        return this.dynamicLayer1Context
      }

      switch (layer) {
          case 1:
              return this.layer1Context
          case 2:
              return this.layer2Context
          case 3:
              return this.layer3Context
      }    
      return this.layer1Context
    },
    getFont: function(fontStyle, fontSize) {
      const fontStyleName = Utils.getFontStyleName(fontStyle)
      return `${fontStyleName} ${fontSize}px "ＭＳ ゴシック"`
    },
    nextElement: function(isDynamic) {
      if (isDynamic) {
        this.indexOfListDynamic++
      } else {
        this.indexOfList++
      }
      this.renderSystemDiagramSetting(isDynamic)
    }
 }
}
</script>